export const PROJECT_INFO_CONSTANTS = {
  SEND_SCHEDULE: 'send_schedule',
  SEND_COMPLETE: 'send_complete',
  SEND_REMINDER_TEXT: 'send_reminder_text',
};

export const PROJECT_NUMBER_API_ERROR_MSG =
  'Error occured while creating project : Project Number already exists, please pick new one ';

export const PROJECT_NUMBER_ERROR_DISPLAY_MSG =
  'This project number is already taken. Please wait while we fetch a new one...';

export const PROJECT_NUMBER_UPDATE_SUCCESS_DISPLAY_MSG =
  'Project number successfully updated';

export const iconColors = [
  'text-indigo-600',
  'text-green-600',
  'text-red-600',
  'text-bluegray-600',
  'text-pink-600',
  'text-blue-600',
  'text-yellow-600',
  'text-purple-600',
  'text-orange-600',
  'text-primary',
  'text-cyan-700',
  'text-teal-600',
];
